module.exports = __webpack_public_path__ + "static/media/cube_card.52fa920d.jpg";